import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'

const LoanPropertyUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // superuser role
  propertyValue, onPropertyValueChange, propertyValueError, setPropertyValueError,
  propertyType, propertySelectList, propertySelectListBool, selectedProperty
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update property'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      propertyType && propertyType !== 'textarea' && propertyType !== 'value_set' && propertyType !== 'boolean_' &&
      <InputTextSF type='text' name='propertyValue' label={selectedProperty.propertyName}
        maxLength={1000} autoFocus={true}
        value={propertyValue} onChange={onPropertyValueChange}
        error={propertyValueError} setError={setPropertyValueError}
        help={`${selectedProperty.hint ? selectedProperty.hint : ''} ${selectedProperty.defaultValue ? ('Default: ' + selectedProperty.defaultValue) : ''}`}
      />
    }
    {
      propertyType === 'textarea' &&
      <InputTextAreaSF type='text' name='propertyValue' label={selectedProperty.propertyName}
        rows="5" maxLength={1000} autoFocus={true}
        value={propertyValue} onChange={onPropertyValueChange}
        error={propertyValueError} setError={setPropertyValueError}
        help={`${selectedProperty.hint ? selectedProperty.hint : ''} ${selectedProperty.defaultValue ? ('Default: ' + selectedProperty.defaultValue) : ''}`}
      />
    }
    {
      propertyType === 'value_set' &&
      <InputSelectSF type='select' name='propertyValue' label={selectedProperty.propertyName}
        value={propertyValue} onChange={onPropertyValueChange} optionList={propertySelectList}
        error={propertyValueError} setError={setPropertyValueError}
        help={`${selectedProperty.hint ? selectedProperty.hint : ''} ${selectedProperty.defaultValue ? ('Default: ' + selectedProperty.defaultValue) : ''}`}
      />
    }
    {
      propertyType === 'boolean_' &&
      <InputSelectSF type='select' name='propertyValue' label={selectedProperty.propertyName}
        value={propertyValue} onChange={onPropertyValueChange} optionList={propertySelectListBool}
        error={propertyValueError} setError={setPropertyValueError}
        help={`${selectedProperty.hint ? selectedProperty.hint : ''} ${selectedProperty.defaultValue ? ('Default: ' + selectedProperty.defaultValue) : ''}`}
      />
    }
  </ModalFormUI>

export default LoanPropertyUpdateModalUI
